import React from 'react';
import PropTypes from 'prop-types';

import FilterItemWrapper from './FilterItemWrapper';
import Filter from './Filter';

class FilterItem extends React.PureComponent {
  handleClick = () => {
    this.props.onClick(this.props.item);
  }

  render() {
    return (
      <FilterItemWrapper>
        <Filter
          type="button"
          onClick={this.handleClick}
          name={this.props.item.value}
          isActive={this.props.activeFilter.value === this.props.item.value}
        >
          {this.props.item.label || this.props.item.value}
        </Filter>
      </FilterItemWrapper>
    );
  }
}

FilterItem.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    value: PropTypes.string,
  }).isRequired,
  activeFilter: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    value: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

FilterItem.defaultProps = {
  activeFilter: {},
  onClick: () => {},
};

export default FilterItem;
